import {Tabs} from 'components/common/Tabs/Tabs';
import styles from './OverviewNavigation.scss';
import lodash from 'lodash';


export default function OverviewNavigation({tabs, location, institution}) {
    const institutionName = lodash.get(institution, 'name', '');
    return (
        <nav className={styles.OverviewNavigation} data-cy="OverviewNavigation">
            <div className={styles.institutionName} data-cy="OverviewNavigation-institutionName">
                {institutionName}
            </div>
            <Tabs tabs={tabs} location={location} />
        </nav>
    );
}
